import memoize from './memoize';

export default memoize(
	(message = 'ra.validation.password_confirmation') => (value, values, { translate }) => {
		const plainPassword = values.user ? values.user.plain_password : values.plain_password;

		return plainPassword === value ? undefined : translate(message);
	}
);
